import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as PIXI from 'pixi.js';


import Grid from '@/components/Grid/Grid.js'

import  { HORIZONTAL, VERTICAL, DIMENSION, POSITION, GUTTER, maxSnapDistancePixels } from '@/util/alignment.js';

import {gridConfig2} from '@/data/gridConfig';

import styles from './AlignmentGuides.css';



function drawDash(target,
    x1,
    y1,
    x2,
    y2,
    dashLength = 5,
    spaceLength = 5) {
let x = x2 - x1;
let y = y2 - y1;
let hyp = Math.sqrt((x) * (x) + (y) * (y));
let units = hyp / (dashLength + spaceLength);
let dashSpaceRatio = dashLength / (dashLength + spaceLength);
let dashX = (x / units) * dashSpaceRatio;
let spaceX = (x / units) - dashX;
let dashY = (y / units) * dashSpaceRatio;
let spaceY = (y / units) - dashY;
target.moveTo(x1, y1);
while (hyp > 0) {
x1 += dashX;
y1 += dashY;
hyp -= dashLength;
if (hyp < 0) {
x1 = x2;
y1 = y2;
}
target.lineTo(x1, y1);
x1 += spaceX;
y1 += spaceY;
target.moveTo(x1, y1);
hyp -= spaceLength;
}
target.moveTo(x2, y2);
}





const actions = {};
const BACKGROUND_COLOR = 'rgba(0,0,0,0)';
const ZONE_COLOR = '#FFCC00';
const GUIDE_COLOR = 0xC87AFF;
const GUIDE_GUTTER_COLOR = 0xC87AFF;
const GUTTER_FILL_ALPHA = 0.2;
const GUIDE_WIDTH = 2;
const GUIDE_ENDCAP_LENGTH = 17;
const GUIDE_DIMENSION_OFFSET = 20;

const TEXT_COLOR_FILL = 'rgba(255, 0, 255, 0.3)';
const TEXT_COLOR_STROKE = 'rgba(255, 0, 255, 1)';
const IMG_COLOR_FILL = 'rgba(255, 101, 0, 0.3)';
const IMG_COLOR_STROKE = 'rgba(255, 101, 0, 1)';

// const IMG_COLOR_FILL = 'rgba(0, 204, 255, 0.3)';
const SELECTED_COLOR_FILL = '#000000';
const SELECTED_COLOR_STROKE = '#0072ff';


/** AlignmentGuides component description */
class AlignmentGuides extends Component {
    constructor(props) {
        super(props);

        this.canvasRef = React.createRef();
    }

    componentDidUpdate() {
        this.draw();
    }

    // shouldComponentUpdate(nextProps, nextState) {
    //     if (nextProps.width !== this.props.width ||
    //         nextProps.height !== this.props.height)
    //     {
    //         return true;
    //     }
    // }

    draw() {

        if (!this.canvasRef.current 
            || !this.canvasRef.current.parentNode
            || this.canvasRef.current.clientWidth == 0
            || this.canvasRef.current.clientHeight == 0
        ) {
            return;
        }

        if (!this.renderer) {

            // this.renderer = new THREE.WebPixiRenderer({
            //     canvas: this.canvasRef.current
            // });

            this.renderer = new PIXI.Application({
                view: this.canvasRef.current,
                antialias: true,
                width: this.canvasRef.current.clientWidth,
                height: this.canvasRef.current.clientHeight,
                transparent: true 
                // resizeTo: this.canvasRef.current.parentNode
            });

        }

    // Scene

        while(this.renderer.stage.children && this.renderer.stage.children[0]) { 
            this.renderer.stage.removeChild(this.renderer.stage.children[0]);
        }

        const props = this.props;
        const config = props.config;

        // const ctx = this.canvasRef.current.getContext("2d");
        // const buff = ctx;//this.offScreenCanvas.getContext("2d");

        const z = this.props.z;
        const panX = this.props.panX;
        const panY = this.props.panY;
        const scale = this.props.scale;
        const w = this.props.width * scale;
        const h = this.props.height * scale;

        // // Background
        // ctx.beginPath();

        // ctx.clearRect(0, 0, w * this.props.marginFactor, h * this.props.marginFactor);
        // if (BACKGROUND_COLOR) {
        //     ctx.rect(0, 0, w * this.props.marginFactor, h * this.props.marginFactor);
        //     ctx.fillStyle = BACKGROUND_COLOR;
        //     ctx.fill();    
        // }
        // ctx.closePath();
        
        // buff.clearRect(0, 0, w, h);


        const halfW = this.props.width/2;
        const halfH = this.props.height/2;



        const focusX = (w*this.props.marginFactor - w)/2;
        const focusY = (h*this.props.marginFactor - h)/2;
        // ctx.beginPath();
        // ctx.rect(
        //     focusX,
        //     focusY,
        //     w, 
        //     h);

        // // console.log(props.config.background)
        // ctx.strokeStyle = ZONE_COLOR;
        // ctx.stroke();
        // ctx.closePath();

        let container1 = new PIXI.Container();
        let container2 = new PIXI.Container();


            // rect2.hitArea = new PIXI.Polygon([
            //     new PIXI.Point(focusX - 50, focusY - 50),
            //     new PIXI.Point(focusX + 150 - 50, focusY - 50),
            //     new PIXI.Point(focusX - 50, focusY + 150 - 50)
            // ]);

            // rect2.interactive = true;

            // rect2.mouseover = function(mouseData) {
            //     rect2.alpha = 1;
            // }
            // rect2.mouseout = function(mouseData) {
            //     rect2.alpha = .5;
            // }
            

         // rect.translateX(x + (item.width * this.props.scale * this.props.z/2))
         // rect.translateY(-(y + (item.height * this.props.scale * this.props.z/2)));
         // this.scene.add(rect);

        //  container2.addChild(rect2);

        this.renderer.stage.addChild(container1);
        this.renderer.stage.addChild(container2);


        if (this.props.isGrabbing) {

            const cx = halfW + (panX * this.props.z);
            const cy = halfH + (panY * this.props.z);

            let firstVertical = true;
            let firstHorizontal = true;
            let firstHorizontalGutter = true;
            let firstVerticalGutter = true;

            this.props.alignments
            .map((alignment, i) => {
                // console.log('alignment', alignment);

                let guide = new PIXI.Graphics();
                let guideLabel;

                if (alignment.type === POSITION) {
                    // console.log('POSITION')



                    let offset = alignment.targetPos - alignment.sourcePos
                    let dist = Math.round(Math.abs(offset))
                    // let dist = Math.round(Math.abs(alignment.targetPos - alignment.sourcePos))

                    if (dist < maxSnapDistancePixels / this.props.z) {

                        if (alignment.axis === HORIZONTAL) {
                            // return;
                            //main axis

                            guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);


                            let snapOffsetMin;
                            let snapOffsetMax;
                            this.props.alignments.map((otherAlignment, j) => {
                                if (otherAlignment !== alignment) {
                                    if (otherAlignment.axis === VERTICAL) {

                                        let otherAlignmentOffset = otherAlignment.targetPos - otherAlignment.sourcePos
                                        let otherAlignmentDist = Math.round(Math.abs(otherAlignmentOffset))

                                        if (otherAlignmentDist < maxSnapDistancePixels / this.props.z) {
                                            if (alignment.source.y == alignment.crossAxisMin) {
                                                snapOffsetMin = otherAlignmentOffset; 
                                                snapOffsetMax = 0;
                                            }
                                            if (alignment.source.y + alignment.source.height == alignment.crossAxisMax) {
                                                snapOffsetMin = 0;
                                                snapOffsetMax = otherAlignmentOffset; 
                                            }
                                        }
                                    }
                                }
                            })
                            if (snapOffsetMin == undefined) {
                                snapOffsetMin = snapOffsetMax = 0;
                            } 

                            drawDash(guide,
                                (alignment.targetPos)*this.props.z, 
                                (alignment.crossAxisMin+snapOffsetMin)*this.props.z,
                                (alignment.targetPos)*this.props.z,
                                (alignment.crossAxisMax+snapOffsetMax)*this.props.z,
                                1000, 0
                            )
                            
                            guide.lineStyle(0);
                            guide.beginFill(GUIDE_COLOR);

                            // redundant if???
                            if (dist > maxSnapDistancePixels / this.props.z) {
                                guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);
                                guide.moveTo(
                                    alignment.sourcePos*this.props.z, 
                                    alignment.crossAxisPos*this.props.z
                                )
                                guide.lineTo(
                                    alignment.targetPos*this.props.z,
                                    alignment.crossAxisPos*this.props.z
                                );

                                let label = dist.toString()
                                let style = new PIXI.TextStyle({fontFamily : 'Barlow', fontSize: 16, fill : 0x000000})
                                let textMetrics = PIXI.TextMetrics.measureText(label, style)
                                
                                guideLabel = new PIXI.Text(label ,style);
                                guideLabel.x = (alignment.sourcePos + (alignment.targetPos - alignment.sourcePos)/2) * this.props.z - textMetrics.width/2
                                guideLabel.y = (alignment.crossAxisPos) * this.props.z - textMetrics.height/2                        
                                
                                let labelPadding = 5;
                                // let textBg = new PIXI.RoundedRectangle(
                                guide.drawRoundedRect(
                                    guideLabel.x - labelPadding,
                                    guideLabel.y,
                                    textMetrics.width + labelPadding*2,
                                    textMetrics.height,
                                    5
                                );
                            }




                        } else if (alignment.axis === VERTICAL) {
                            // 
                            //main axis
                            guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR); // GUIDE_COLOR

                            //cross axis
                            /*
                                guide.moveTo(
                                    alignment.crossAxisMin*this.props.z,
                                    alignment.targetPos*this.props.z
                                )
                                guide.lineTo(
                                    alignment.crossAxisMax*this.props.z,
                                    alignment.targetPos*this.props.z
                                );
                            */

                            let snapOffsetMin;
                            let snapOffsetMax;
                            this.props.alignments.map((otherAlignment, j) => {
                                if (otherAlignment !== alignment) {
                                    if (otherAlignment.axis === HORIZONTAL) {

                                        let otherAlignmentOffset = otherAlignment.targetPos - otherAlignment.sourcePos
                                        let otherAlignmentDist = Math.round(Math.abs(otherAlignmentOffset))

                                        if (otherAlignmentDist < maxSnapDistancePixels / this.props.z) {
                                            if (alignment.source.x == alignment.crossAxisMin) {
                                                snapOffsetMin = otherAlignmentOffset; 
                                                snapOffsetMax = 0;
                                            }
                                            if (alignment.source.x + alignment.source.width == alignment.crossAxisMax) {
                                                snapOffsetMin = 0;
                                                snapOffsetMax = otherAlignmentOffset; 
                                            }
                                        }
                                    }
                                }
                            })

                            // console.log('snap', offset, snapOffsetMin, snapOffsetMax);
 
                            if (snapOffsetMin == undefined) {
                                // console.log('taint!', alignment);
                                snapOffsetMin = snapOffsetMax = 0;
                                // guide.lineStyle(3, 0xFF0000);
                            } 

                            drawDash(guide,
                                (alignment.crossAxisMin + snapOffsetMin) * this.props.z,
                                (alignment.targetPos)*this.props.z,
                                (alignment.crossAxisMax + snapOffsetMax) * this.props.z,
                                (alignment.targetPos)*this.props.z,
                                1000, 0
                            )
                            

                            guide.lineStyle(0);
                            guide.beginFill(GUIDE_COLOR);

                            if (dist > maxSnapDistancePixels / this.props.z) {
                                guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);

                                guide.moveTo(
                                    alignment.crossAxisPos*this.props.z,
                                    alignment.sourcePos*this.props.z
                                )
                                guide.lineTo(
                                    alignment.crossAxisPos*this.props.z,
                                    alignment.targetPos*this.props.z
                                );

                                let label = Math.round(Math.abs(alignment.targetPos - alignment.sourcePos)).toString()
                                let style = new PIXI.TextStyle({fontFamily : 'Barlow', fontSize: 16, fill : 0x000000})
                                let textMetrics = PIXI.TextMetrics.measureText(label, style)
                                guideLabel = new PIXI.Text(label ,style);
                                guideLabel.x = (alignment.crossAxisPos) * this.props.z - textMetrics.width/2
                                guideLabel.y = (alignment.sourcePos + (alignment.targetPos - alignment.sourcePos)/2) * this.props.z - textMetrics.height/2


                                let labelPadding = 5;
                                // let textBg = new PIXI.RoundedRectangle(
                                guide.drawRoundedRect(
                                    guideLabel.x - labelPadding,
                                    guideLabel.y,
                                    textMetrics.width + labelPadding*2,
                                    textMetrics.height,
                                    5
                                );
                            }
                        }



                    }
                } else if (alignment.type === DIMENSION) {
                    // console.log('DIMENSION!', alignment)

                    let offset = alignment.targetDim - alignment.sourceDim;
                    let dist = Math.round(Math.abs(offset))

                    console.log('dist' , alignment.targetDim - alignment.sourceDim, alignment)

                    if (dist < maxSnapDistancePixels / this.props.z) {

                        if (alignment.axis === HORIZONTAL) {

                            guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);

                            // drawDash(guide,
                            guide.moveTo(
                            (alignment.target.x) * this.props.z,
                                alignment.target.y * this.props.z - GUIDE_DIMENSION_OFFSET
                            );
                            guide.lineTo(
                                (alignment.target.x + alignment.target.width) * this.props.z,
                                alignment.target.y * this.props.z - GUIDE_DIMENSION_OFFSET
                            )


                            // start cap
                            guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);
                            guide.moveTo(
                                alignment.target.x * this.props.z,
                                alignment.target.y * this.props.z - GUIDE_DIMENSION_OFFSET - (GUIDE_ENDCAP_LENGTH/2)
                            );
                            guide.lineTo(
                                alignment.target.x * this.props.z,
                                alignment.target.y * this.props.z - GUIDE_DIMENSION_OFFSET + (GUIDE_ENDCAP_LENGTH/2)
                            )


                            // end cap
                            guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);
                            guide.moveTo(
                                (alignment.target.x + alignment.target.width) * this.props.z,
                                alignment.target.y * this.props.z - GUIDE_DIMENSION_OFFSET - (GUIDE_ENDCAP_LENGTH/2)
                            );
                            guide.lineTo(
                                (alignment.target.x + alignment.target.width) * this.props.z,
                                alignment.target.y * this.props.z - GUIDE_DIMENSION_OFFSET + (GUIDE_ENDCAP_LENGTH/2)
                            )

                            // guide.lineStyle(0);
                            // guide.beginFill(GUIDE_COLOR);

                            guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);



                            if (firstHorizontal) {
                                firstHorizontal = false;
                                guide.lineStyle(2, GUIDE_COLOR);

                                // drawDash(guide,
                                guide.moveTo(
                                    (alignment.source.x - offset/2) * this.props.z,
                                    (alignment.source.y) * this.props.z - GUIDE_DIMENSION_OFFSET
                                );
                                guide.lineTo(
                                    (alignment.source.x + alignment.target.width - offset/2) * this.props.z,
                                    (alignment.source.y) * this.props.z - GUIDE_DIMENSION_OFFSET
                                )
    
    
                                // start cap
                                guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);
                                guide.moveTo(
                                    (alignment.source.x - offset/2) * this.props.z,
                                    alignment.source.y * this.props.z - GUIDE_DIMENSION_OFFSET - (GUIDE_ENDCAP_LENGTH/2)
                                );
                                guide.lineTo(
                                    (alignment.source.x - offset/2) * this.props.z,
                                    alignment.source.y * this.props.z - GUIDE_DIMENSION_OFFSET + (GUIDE_ENDCAP_LENGTH/2)
                                )
    
    
                                // end cap
                                guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);
                                guide.moveTo(
                                    (alignment.source.x + alignment.target.width - offset/2) * this.props.z,
                                    alignment.source.y * this.props.z - GUIDE_DIMENSION_OFFSET - (GUIDE_ENDCAP_LENGTH/2)
                                );
                                guide.lineTo(
                                    (alignment.source.x + alignment.target.width - offset/2) * this.props.z,
                                    alignment.source.y * this.props.z - GUIDE_DIMENSION_OFFSET + (GUIDE_ENDCAP_LENGTH/2)
                                )
                            }











                        } else if (alignment.axis === VERTICAL) {

                            // drawDash(guide,
                            guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);
                            guide.moveTo(
                                alignment.target.x * this.props.z - GUIDE_DIMENSION_OFFSET,
                                alignment.target.y * this.props.z )
                            guide.lineTo(  
                                alignment.target.x * this.props.z - GUIDE_DIMENSION_OFFSET,
                                (alignment.target.y+ alignment.target.height) * this.props.z
                            )

                            
                            // start cap
                            guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);
                            guide.moveTo(
                                alignment.target.x * this.props.z - GUIDE_DIMENSION_OFFSET - (GUIDE_ENDCAP_LENGTH/2),
                                alignment.target.y * this.props.z
                            )
                            guide.lineTo(  
                                alignment.target.x * this.props.z - GUIDE_DIMENSION_OFFSET + (GUIDE_ENDCAP_LENGTH/2),
                                alignment.target.y * this.props.z
                            )

                            // end cap
                            guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);
                            guide.moveTo(
                                alignment.target.x * this.props.z - GUIDE_DIMENSION_OFFSET - (GUIDE_ENDCAP_LENGTH/2),
                                (alignment.target.y+ alignment.target.height) * this.props.z
                            )
                            guide.lineTo(  
                                alignment.target.x * this.props.z - GUIDE_DIMENSION_OFFSET + (GUIDE_ENDCAP_LENGTH/2),
                                (alignment.target.y+ alignment.target.height) * this.props.z
                            )


                            if (firstVertical) {
                                firstVertical = false;
                            
                                guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);
                                guide.moveTo(
                                    alignment.source.x * this.props.z - GUIDE_DIMENSION_OFFSET,
                                    (alignment.source.y - offset/2) * this.props.z
                                )
                                guide.lineTo(  
                                    alignment.source.x * this.props.z - GUIDE_DIMENSION_OFFSET,
                                    (alignment.source.y + alignment.target.height - offset/2) * this.props.z
                                )
    
                                
                                // start cap
                                guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);
                                guide.moveTo(
                                    alignment.source.x * this.props.z - GUIDE_DIMENSION_OFFSET - (GUIDE_ENDCAP_LENGTH/2),
                                    (alignment.source.y - offset/2) * this.props.z
                                )
                                guide.lineTo(  
                                    alignment.source.x * this.props.z - GUIDE_DIMENSION_OFFSET + (GUIDE_ENDCAP_LENGTH/2),
                                    (alignment.source.y - offset/2) * this.props.z
                                )
    
                                // end cap
                                guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);
                                guide.moveTo(
                                    alignment.source.x * this.props.z - GUIDE_DIMENSION_OFFSET - (GUIDE_ENDCAP_LENGTH/2),
                                    (alignment.source.y + alignment.target.height - offset/2) * this.props.z
                                )
                                guide.lineTo(  
                                    alignment.source.x * this.props.z - GUIDE_DIMENSION_OFFSET + (GUIDE_ENDCAP_LENGTH/2),
                                    (alignment.source.y + alignment.target.height - offset/2) * this.props.z
                                )
                            
                            }

                            // guide.lineStyle(0);
                            // guide.beginFill(GUIDE_COLOR);

                            guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);
                        }
                    }
                } else








                if (alignment.type === GUTTER) {
                    // console.log('GUTTER', alignment)

                    let dist = 0;//Math.round(Math.abs(alignment.targetPos - alignment.sourcePos))

                    if (dist < maxSnapDistancePixels / this.props.z) {
                        // console.log('draw gutter')
                        if (alignment.axis === HORIZONTAL) {

                            guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);

                            /*
                            type: GUTTER,
                            source,
                            target,
                            sourceGutter,
                            targetGutter
                            */


                            let minCross, maxCross;

                            if (firstHorizontalGutter) {
                                firstHorizontalGutter = false

                                // console.log("FIRST HOR", alignment.sourceGutter, alignment.targetGutter)

                                let offset = alignment.sourceGutter.gutter - alignment.targetGutter.gutter;

                                let offsetX = 0;
                                let offsetW = 0;

                                if (this.props.content.selection.indexOf(alignment.sourceGutter.itemA.id) !== -1) {
                                    offsetX = offset;
                                    offsetW = -offset;
                                }
                                if (this.props.content.selection.indexOf(alignment.sourceGutter.itemB.id) !== -1) {
                                    // offsetX = offset;
                                    offsetW = -offset;
                                }

                                // console.log('offset', offsetX, offsetW);

                                let dist = Math.round(Math.abs(offset))
    
                                // console.log('content gutter snap', offset, dist);
    

                                minCross = Math.min(
                                    alignment.sourceGutter.itemA.y, 
                                    alignment.sourceGutter.itemB.y
                                );
                                maxCross = Math.max(
                                    alignment.sourceGutter.itemA.y + alignment.sourceGutter.itemA.height,
                                    alignment.sourceGutter.itemB.y + alignment.sourceGutter.itemB.height
                                );

                                guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);
                                guide.beginFill(GUIDE_GUTTER_COLOR, GUTTER_FILL_ALPHA);
    
                                /*
                                if (dist < maxSnapDistancePixels / this.props.z) {
                                    if (alignment.axis === HORIZONTAL) {
                                        x = item.x + offset
                                    } else if (alignment.axis === VERTICAL) {
                                        y = item.y + offset
                                    } 
                                }
                                */




                                guide.drawRect(
                                    (alignment.sourceGutter.itemA.x + alignment.sourceGutter.itemA.width + offsetX) * this.props.z, 
                                    (minCross) * this.props.z,
                                    (alignment.sourceGutter.itemB.x - (alignment.sourceGutter.itemA.x + alignment.sourceGutter.itemA.width) + offsetW) * this.props.z,
                                    (maxCross - minCross) * this.props.z,
                                    1000, 0
                                )
                                guide.endFill()

                            }




                            minCross = Math.min(
                                alignment.targetGutter.itemA.y, 
                                alignment.targetGutter.itemB.y
                            );
                            maxCross = Math.max(
                                alignment.targetGutter.itemA.y + alignment.targetGutter.itemA.height,
                                alignment.targetGutter.itemB.y + alignment.targetGutter.itemB.height
                            );

                            // console.log(
                            //     alignment.targetGutter.itemA.id, alignment.targetGutter.itemB.id
                            // );
                            //     (alignment.targetGutter.itemA.x + alignment.targetGutter.itemA.width), 
                            //     (minCross),
                            //     (alignment.targetGutter.itemB.x) - (alignment.targetGutter.itemA.x + alignment.targetGutter.itemA.width),
                            //     (maxCross-minCross)
                            // )                            

                            guide.lineStyle(1, GUIDE_COLOR);
                            guide.beginFill(
                                GUIDE_GUTTER_COLOR,
                                GUTTER_FILL_ALPHA);

                            let rx = (alignment.targetGutter.itemA.x + alignment.targetGutter.itemA.width) * this.props.z;
                            let ry = (minCross) * this.props.z;
                            let rw = (alignment.targetGutter.itemB.x - (alignment.targetGutter.itemA.x + alignment.targetGutter.itemA.width)) * this.props.z;
                            let rh = (maxCross - minCross) * this.props.z;

                            // console.log(alignment.targetGutter.itemA.id, alignment.targetGutter.itemB.id, rx, ry, ':', rw, rh)

                            guide.drawRect(
                                rx, ry, rw, rh
                            )
                            guide.endFill()
                            
                            guide.lineStyle(0);
                            guide.beginFill(GUIDE_COLOR);


                            if (dist > maxSnapDistancePixels / this.props.z) {
                                guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);
                                guide.moveTo(
                                    alignment.sourcePos * this.props.z, 
                                    alignment.crossAxisPos * this.props.z
                                )
                                guide.lineTo(
                                    alignment.targetPos * this.props.z,
                                    alignment.crossAxisPos * this.props.z
                                );

                                let label = dist.toString()
                                let style = new PIXI.TextStyle({fontFamily : 'Barlow', fontSize: 16, fill : 0x000000})
                                let textMetrics = PIXI.TextMetrics.measureText(label, style)
                                
                                guideLabel = new PIXI.Text(label ,style);
                                guideLabel.x = (alignment.sourcePos + (alignment.targetPos - alignment.sourcePos)/2) * this.props.z - textMetrics.width/2
                                guideLabel.y = (alignment.crossAxisPos) * this.props.z - textMetrics.height/2                        
                                
                                let labelPadding = 5;
                                // let textBg = new PIXI.RoundedRectangle(
                                guide.drawRoundedRect(
                                    guideLabel.x - labelPadding,
                                    guideLabel.y,
                                    textMetrics.width + labelPadding*2,
                                    textMetrics.height,
                                    5
                                );
                            }




                        } else if (alignment.axis === VERTICAL) {
                            // 
                            guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);


                            /*
                            type: GUTTER,
                            source,
                            target,
                            sourceGutter,
                            targetGutter
                            */


                            let minCross, maxCross;

                            if (firstVerticalGutter) {
                                firstVerticalGutter = false

                                // console.log("FIRST HOR", alignment.sourceGutter, alignment.targetGutter)

                                let offset = alignment.sourceGutter.gutter - alignment.targetGutter.gutter;

                                let offsetY = 0;
                                let offsetH = 0;

                                if (this.props.content.selection.indexOf(alignment.sourceGutter.itemA.id) !== -1) {
                                    offsetY = offset;
                                    offsetH = -offset;
                                }
                                if (this.props.content.selection.indexOf(alignment.sourceGutter.itemB.id) !== -1) {
                                    // offsetY = offset;
                                    offsetH = -offset;
                                }

                                // console.log('offset', offsetY, offsetH);

                                let dist = Math.round(Math.abs(offset))
    
                                // console.log('content gutter snap', offset, dist);
    

                                minCross = Math.min(
                                    alignment.sourceGutter.itemA.x, 
                                    alignment.sourceGutter.itemB.x
                                );
                                maxCross = Math.max(
                                    alignment.sourceGutter.itemA.x + alignment.sourceGutter.itemA.width,
                                    alignment.sourceGutter.itemB.x + alignment.sourceGutter.itemB.width
                                );

                                guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);
                                guide.beginFill(GUIDE_GUTTER_COLOR, GUTTER_FILL_ALPHA);
    


                                guide.drawRect(
                                    (minCross) * this.props.z,
                                    (alignment.sourceGutter.itemA.y + alignment.sourceGutter.itemA.height + offsetY) * this.props.z, 
                                    (maxCross - minCross) * this.props.z,
                                    (alignment.sourceGutter.itemB.y - (alignment.sourceGutter.itemA.y + alignment.sourceGutter.itemA.height) + offsetH) * this.props.z,
                                    1000, 0
                                )
                                guide.endFill()

                            }




                            minCross = Math.min(
                                alignment.targetGutter.itemA.x, 
                                alignment.targetGutter.itemB.x
                            );
                            maxCross = Math.max(
                                alignment.targetGutter.itemA.x + alignment.targetGutter.itemA.width,
                                alignment.targetGutter.itemB.x + alignment.targetGutter.itemB.width
                            );


                            guide.lineStyle(1, GUIDE_COLOR);
                            guide.beginFill(
                                GUIDE_GUTTER_COLOR,
                                GUTTER_FILL_ALPHA);

                            let rx = (minCross) * this.props.z;
                            let ry = (alignment.targetGutter.itemA.y + alignment.targetGutter.itemA.height) * this.props.z;
                            let rw = (maxCross - minCross) * this.props.z;
                            let rh = (alignment.targetGutter.itemB.y - (alignment.targetGutter.itemA.y + alignment.targetGutter.itemA.height)) * this.props.z;

                            // console.log(alignment.targetGutter.itemA.id, alignment.targetGutter.itemB.id, rx, ry, ':', rw, rh)

                            guide.drawRect(
                                rx, ry, rw, rh
                            )
                            guide.endFill()
                            
                            guide.lineStyle(0);
                            guide.beginFill(GUIDE_COLOR);


                            if (dist > maxSnapDistancePixels / this.props.z) {
                                guide.lineStyle(GUIDE_WIDTH, GUIDE_COLOR);
                                guide.moveTo(
                                    alignment.sourcePos * this.props.z, 
                                    alignment.crossAxisPos * this.props.z
                                )
                                guide.lineTo(
                                    alignment.targetPos * this.props.z,
                                    alignment.crossAxisPos * this.props.z
                                );

                                let label = dist.toString()
                                let style = new PIXI.TextStyle({fontFamily : 'Barlow', fontSize: 16, fill : 0x000000})
                                let textMetrics = PIXI.TextMetrics.measureText(label, style)
                                
                                guideLabel = new PIXI.Text(label ,style);
                                guideLabel.x = (alignment.sourcePos + (alignment.targetPos - alignment.sourcePos)/2) * this.props.z - textMetrics.width/2
                                guideLabel.y = (alignment.crossAxisPos) * this.props.z - textMetrics.height/2                        
                                
                                let labelPadding = 5;
                                // let textBg = new PIXI.RoundedRectangle(
                                guide.drawRoundedRect(
                                    guideLabel.x - labelPadding,
                                    guideLabel.y,
                                    textMetrics.width + labelPadding*2,
                                    textMetrics.height,
                                    5
                                );
                            }



                        }



                    }
                }











                if (guide) {
                    guide.x = cx;
                    guide.y = cy;
                    this.renderer.stage.addChild(guide);
                }


                if (guideLabel) {
                    guideLabel.x += cx;
                    guideLabel.y += cy;
                    this.renderer.stage.addChild(guideLabel);
                }


            });

        }


        Object.values(this.props.media)
            // .filter((item) => {
            //     return (onScreenMedia.indexOf(item.id) !== -1 
            //     || 
            //     this.props.content.selection.length && this.props.content.selection.indexOf(item.id) !== -1)
            // })
            .map((item) => {

            // const transform = this.props.transform;
            const selected = this.props.content.selection.length && this.props.content.selection.indexOf(item.id) !== -1;
            const active = this.props.content.active.length && this.props.content.active.indexOf(item.id) !== -1;
            const hovered = this.props.content.hover.length && this.props.content.hover.indexOf(item.id) !== -1;
            const fg = [];

            if (selected) {                
                // fg.push(this.selectIndicator);

                if (this.props.content.selection.length == 1) {
                    // fg.push(this.buildContextMenu(item))
                }                
            }
            if (hovered) {
                // fg.push(this.props.hoverIndicator);
            }

            if (selected && this.props.content.selection.length == 1) {
                // fg.push(this.props.resizeControl)
            }

           
            // console.log(transform);

            // console.log(item);
            // const x = 0 + ((item.x + this.props.panX) * this.props.z) * this.props.scale;
            // const y = 0 + ((item.y + this.props.panY) * this.props.z) * this.props.scale;
            //const x = w/2// + ((0 + this.props.panX) * this.props.scale * this.props.z );// * this.props.z + this.props.width) * this.props.scale;
            //const y = h/2// + ((0 + this.props.panY) * this.props.scale * this.props.z );// * this.props.z + this.props.height) * this.props.scale;
            const x = focusX + ((item.x + this.props.panX) * this.props.z + this.props.width/2) * this.props.scale;
            const y = focusY + ((item.y + this.props.panY) * this.props.z + this.props.height/2) * this.props.scale;

            switch (item.type) {
                case 'text': {
                    // console.log('text', item);

                    // ctx.beginPath();
                    // ctx.rect(
                    //     x,
                    //     y,
                    //     item.width * this.props.scale * this.props.z, 
                    //     item.height * this.props.scale * this.props.z
                    // );

                    // // console.log(props.config.background)

                    // ctx.fillStyle = selected ? SELECTED_COLOR_FILL : TEXT_COLOR_FILL;
                    // ctx.fill();

                    // ctx.strokeStyle = selected ? SELECTED_COLOR_STROKE : TEXT_COLOR_STROKE;
                    // ctx.stroke();

                    // ctx.closePath();
                    break;

                }
                    // return <Textfield 
                    //     key={'text-' + item.id}
                    //     selected={selected}
                    //     active={active}
                    //     dragging={this.props.isGrabbing}
                    //     {...item}
                    //     fg={fg}
                    // />

                case 'img':
                default: {
                    // console.log('img', item);

                    // GEOMETRY
                    /* 
                    var geometry = new THREE.Geometry();
                    geometry.vertices.push(
                        new THREE.Vector3(x, -y, 0),
                        new THREE.Vector3(
                            (x + (item.width * this.props.scale * this.props.z)), 
                            -(y + (item.height * this.props.scale * this.props.z)),
                            0
                        )
                    );
                
                    // The Line
                    var line = new THREE.Line(geometry, new THREE.LineBasicMaterial({
                                color: 0xFFFFFF
                            }));
                    this.scene.add(line);
                    */

                    /*
                    var geometry = new THREE.PlaneGeometry(
                        item.width * this.props.scale * this.props.z,
                        item.height * this.props.scale * this.props.z
                    );
                    var rect = new THREE.Mesh(geometry, new THREE.MeshBasicMaterial({
                        color: 0xFFFFFF,
                        side: THREE.DoubleSide
                    }));
                    */


                    /*
                    var rect = new PIXI.Graphics();

                    //    rect.beginFill(0xFFFFFF);
                    
                    // set the line style to have a width of 5 and set the color to red
                    rect.lineStyle(2, GUIDE_COLOR);
                    
                    // draw a rectangle
                    // rect.drawRect(
                    //     x,// + (item.width * this.props.scale * this.props.z/2)
                    //     y,//(item.y + this.props.panY * this.props.scale * this.props.z),// + (item.height * this.props.scale * this.props.z/2),
                    //     item.width * this.props.scale * this.props.z,
                    //     item.height * this.props.scale * this.props.z
                    // );

                    rect.moveTo(x,y)
                    rect.lineTo(
                        x + item.width * this.props.scale * this.props.z,
                        y + item.height * this.props.scale * this.props.z
                    );


                    let style = new PIXI.TextStyle({fontFamily : 'Barlow', fontSize: 16, fill : 0xFFFFFF})
                    let textMetrics = PIXI.TextMetrics.measureText(Math.round(item.width).toString(), style)
                    let text = new PIXI.Text(Math.round(item.width).toString() ,style);
                    text.x = x + ((item.width * this.props.scale * this.props.z) - textMetrics.width)/2
                    text.y = y + ((item.height * this.props.scale * this.props.z) - textMetrics.height)/2


                    rect.lineStyle(0);
                    rect.beginFill(GUIDE_COLOR);
                    let labelPadding = 5;
                    // let textBg = new PIXI.RoundedRectangle(
                    rect.drawRoundedRect(
                        text.x - labelPadding,
                        text.y ,
                        textMetrics.width + labelPadding*2,
                        textMetrics.height ,
                        5
                    )

                    // rect.translateX(x + (item.width * this.props.scale * this.props.z/2))
                    // rect.translateY(-(y + (item.height * this.props.scale * this.props.z/2)));
                    // this.scene.add(rect);

                    this.renderer.stage.addChild(rect);
                    // this.renderer.stage.addChild(textBg);
                    this.renderer.stage.addChild(text);
*/
                    // ctx.beginPath();
                    // ctx.rect(
                    //     x, 
                    //     y, 
                    //     item.width * this.props.scale * this.props.z, 
                    //     item.height * this.props.scale * this.props.z
                    // );

                    // // console.log(props.config.background)
                    // ctx.fillStyle = selected ? SELECTED_COLOR_FILL : IMG_COLOR_FILL;
                    // ctx.fill();

                    // ctx.strokeStyle = selected ? SELECTED_COLOR_STROKE : IMG_COLOR_STROKE;
                    // ctx.stroke();


                    // ctx.closePath();
                    // ctx.fill();
                }
                //     return <CanvasExample 
                //     // hidden={ item.id in onScreenMedia }
                //     key={'canvas-ex-' + item.id}
                //     selected={selected}
                //     dragging={this.props.isGrabbing}
                //     {...item}
                //     fg={fg}
                // ></CanvasExample>
            }
        });
        

        // // GEOMETRY
        // var geometry = new THREE.Geometry();
        // geometry.vertices.push(
        //     new THREE.Vector3(-2, -2, 0),
        //     new THREE.Vector3(
        //         2, 
        //         2,
        //         0
        //     )
        // );
    
        // // The Line
        // var line = new THREE.Line(geometry, new THREE.LineBasicMaterial({
        //             color: 0xFFCC00
        //         }));
        // this.scene.add(line);

        // var geometry = new THREE.Geometry();
        // geometry.vertices.push(
        //     new THREE.Vector3(-10, 5, 0),
        //     new THREE.Vector3(
        //         2, 
        //         -2,
        //         0
        //     )
        // );
    
        // // The Line
        // var line = new THREE.Line(geometry, new THREE.LineBasicMaterial({
        //             color: 0xCC0000
        //         }));
        // this.scene.add(line);


        // this.renderer.setSize(this.props.width, this.props.height);
        // this.renderer.render(this.scene, this.camera);

    }

    render() {
        // console.log('render');
        let w = this.props.width * this.props.scale * this.props.marginFactor;
        let h = this.props.height * this.props.scale * this.props.marginFactor;
        // console.log(w,h, this.props.width, this.props.scale, this.props.marginFactor)

        // this.scene = new THREE.Scene();
 
        // Camera
        // this.camera = new THREE.PerspectiveCamera();
        // this.camera.position.set(0, 0, 55);
        // this.camera.lookAt(0, 0, 0);



        return <div 
            className={`AlignmentGuides animate ${(this.props.open ? 'open' : 'closed')}`}
            style={{
                zIndex: 100,
                width: w+'px',
                height: h+'px'
            }}
        >

            <canvas
                className="map"
                ref={this.canvasRef}
                width={ w }
                height={ h }
            />
            {/* <Grid 
                width={ w }
                height={ h }
                config={ gridConfig2 }
                scale={ 2.5/10 }
            >
            </Grid> */}

        </div>;
    }
}

const mapStateToProps = (state, ownProps) => {
    const marginFactor = 1;
    const scale = 1;

    return Object.assign({}, { 
        content: state.content,
        media: state.content.media, //getMediaSelector(state), // state.content.media, //

        width: state.camera.size.width, 
        height: state.camera.size.height,
        panX: state.camera.pan.x, 
        panY: state.camera.pan.y,

        z: state.camera.zoom,

        isGrabbing: state.cursor.isGrabbing,

        scale,
        marginFactor,
    }, ownProps);
}

AlignmentGuides.displayName = "AlignmentGuidesComponent";
const connectedComponent = connect(
    mapStateToProps,
    {
        ...actions
    }
)(AlignmentGuides);
connectedComponent.displayName = "AlignmentGuides";


AlignmentGuides.propTypes = {
    open: PropTypes.bool,
    alignments: PropTypes.array
    // isShowingAll: PropTypes.bool,
    // showAll: PropTypes.func,
    // showPrev: PropTypes.func
};

export default connectedComponent;
export { AlignmentGuides as AlignmentGuidesComponent };